import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { contains, __ } from 'ramda';
import { withAsyncActions } from 'react-async-client';
import { Button } from 'antd';
import { withRouter } from 'react-router';
import Translate from 'react-translate-component';

import { ACTIONS_ENABLED_STATUSES } from 'constants/approvalStatuses';
import { fullAutoOptions } from 'constants/asyncClient';
import { getRequest } from 'actions/asyncActions';
import { openModalCancelRequest } from 'actions/modalActions';
import CustomIcon from 'components/common/CustomIcon';

import SidebarContainer from '../SidebarContainer';
import { RequestBasic } from './fields/RequestBasic';
import { RequestWorkConditions } from './fields/RequestWorkConditions';
import { RequestRequirementsForCandidate } from './fields/RequestRequirementsForCandidate';
import { RequestPersonalQualities } from './fields/RequestPersonalQualities';
import { RequestAdditionalInformation } from './fields/RequestAdditionalInformation';
import { RequestStatus } from './fields/RequestStatus';

import ApprovalButtons from 'components/common/controls/approvals/ApprovalButtons';

const isCancellable = contains(__, ACTIONS_ENABLED_STATUSES);

@withRouter
@connect(null, { openModalCancelRequest })
@withAsyncActions({
    getRequest: getRequest.withPayload(({ id }) => id)
}, fullAutoOptions)
export default class RequestSidebar extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
        params: PropTypes.object,
        history: PropTypes.object,
        getRequest: PropTypes.object.isRequired,
        openModalCancelRequest: PropTypes.func.isRequired
    };

    getSameRequestBtn = (selected) => {
        const { history } = this.props;

        return <Button
            icon={<CustomIcon type='send' />}
            onClick={() => history.push(`/add/request/${selected}`)}>
            <Translate content='button.sameRequest' />
        </Button>;
    }

    getFooter = (request) => (
        <ApprovalButtons selected={request} filters={{ status: 'inwork' }} cancel={() => this.props.openModalCancelRequest([request])} />
    )

    getFooterCopy = (request) => (
        <ApprovalButtons selected={request} buttons={this.getSameRequestBtn(request.id)} />
    )

    render() {
        const { params, getRequest: { data: request, meta } } = this.props;

        const cancellable = meta.success && isCancellable(request.status);
        const title = meta.success ? request.position : params.title;
        const footer = cancellable ? this.getFooter(request) : this.getFooterCopy(request);

        return (
            <SidebarContainer meta={meta} title={title} footer={request.id ? footer : null}>
                {meta.success && (
                    <div>
                        <RequestBasic request={request} />
                        <RequestWorkConditions request={request} />
                        <RequestRequirementsForCandidate request={request} />
                        {request.personality && <RequestPersonalQualities personality={request.personality} />}
                        {request.comment && <RequestAdditionalInformation information={request.comment} />}
                        <RequestStatus comments={request.comments} status={request.status} />
                    </div>
                )}
            </SidebarContainer>
        );
    }
}
